<template>
  <div class="home">
    <nav id="myHeader" class="navbar navbar-light navbar-expand">
      <!-- <div class="container-fluid"> -->
      <a class="navbar-brand" href="/">tkyk</a>
      <div class="navbar-nav">
        <!-- <a class="nav-item nav-link" href="#/garally">garally</a> -->
        <a class="nav-item nav-link" href="#project">project</a>
        <a class="nav-item nav-link" href="#profile">profile</a>
      </div>
      <!-- </div> -->
    </nav>

    <JumboP5/>
    <MyProject/>
    <Work />
    <!-- <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
    <Profile/>
    <!-- <Skill /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import JumboP5 from "@/components/jumboP5.vue";
import MyProject from "@/components/project.vue";
import Work from "@/components/pri/work_pri.vue";
import Profile from "@/components/pri/profile_pri.vue";
import Skill from "@/components/pri/skill_pri.vue";

export default {
  name: "home",
  components: {
    JumboP5,
    MyProject,
    Work,
    Profile,
    Skill
  }
};
</script>

<style>
#myHeader {
  padding: 0rem;
  padding-left: 1rem;
  height: 2rem;
}
</style>













